import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ChannelFilterContext } from '../../contexts/ChannelFilterContext'


export const ChannelSelectorForm = ({ onChange }) => {
  const {state, dispatch} = useContext(ChannelFilterContext)
  const { t } = useTranslation()

  const handleSelectorTypeChanged = (event) => {
    if (event.target && event.target.value) {
      const {value, checked} = event.target
      // const [_, selectorType] = name.split(/\.(.+)/)
      if (checked) {
        dispatch({
          type: 'SET_SELECTOR_TYPE',
          value: value,
        })
      }
    }    
  }

  const handleCheckedStateChanged = (event) => {
    if (event.target && event.target.name) {
      const {name, checked: value} = event.target
      const [category, key] = name.split(/\.(.+)/)
      if (category && key) {
        dispatch({
          type: 'SET_FILTER_VALUE',
          category,
          key,
          value,
        })
      }
    }    
  }

  const handleCustomInputValueChanged = (event) => {
    if (event.target) {
      const {value} = event.target
      const codes = value.split(',').map(code => code.trim()).filter(code => code)
      dispatch({
        type: 'SET_FILTER_CODES',
        value: codes
      })
    }
  }

  return (
    <>
      <label className="datatable_select_radio2 mb4" htmlFor="channelFilter.selectorType.all">
        <input type="radio" id="channelFilter.selectorType.all"
          name="selectorType" value="all" className="with-gap" 
          checked={state.selectorType === 'all'}
          onChange={handleSelectorTypeChanged}
        />
        <span>{t('form.all')}</span>
      </label>
      <label className="datatable_select_radio2 mb4" htmlFor="channelFilter.selectorType.byFeatures">
        <input type="radio" id="channelFilter.selectorType.byFeatures"
          name="selectorType" value="byFeatures" className="with-gap" 
          checked={state.selectorType === 'byFeatures'}
          onChange={handleSelectorTypeChanged}
        />
        <span>{t('form.selectByFeatures')}</span>
      </label>
      {state.selectorType === 'byFeatures' && 
        <div className="datatable_select_radio2">
          <div className="datatable_select_check">
            <span>Sample Rate:</span>
            <label htmlFor="channelFilter.byFeatures._20sps">
              <input type="checkbox" id="channelFilter.byFeatures._20sps"
                name="byFeatures._20sps" className="filled-in"
                onChange={handleCheckedStateChanged}
              />
              <span>20 sps</span>
            </label>
            <label htmlFor="channelFilter.byFeatures._100sps">
              <input type="checkbox" id="channelFilter.byFeatures._100sps"
                name="byFeatures._100sps" className="filled-in"
                onChange={handleCheckedStateChanged}
              />
              <span>100 sps</span>
            </label>
          </div>
          <div className="datatable_select_check">
            <span>{t('form.channel.installationPosition.title')}:</span>
            <label htmlFor="channelFilter.byFeatures.surface">
              <input type="checkbox" id="channelFilter.byFeatures.surface"
                name="byFeatures.surface" className="filled-in"
                onChange={handleCheckedStateChanged}
              />
              <span>{t('form.channel.installationPosition.surface')}</span>
            </label>
            <label htmlFor="channelFilter.byFeatures.borehole">
              <input type="checkbox" id="channelFilter.byFeatures.borehole"
                name="byFeatures.borehole" className="filled-in"
                onChange={handleCheckedStateChanged}
              />
              <span>{t('form.channel.installationPosition.borehole')}</span>
            </label>          
          </div>
          <div className="datatable_select_check">
            <span>{t('form.channel.sensorType.title')}:</span>
            <label htmlFor="channelFilter.byFeatures.shortperiod">
              <input type="checkbox" id="channelFilter.byFeatures.shortperiod"
                name="byFeatures.shortperiod" className="filled-in"
                onChange={handleCheckedStateChanged}
              />
              <span>{t('form.channel.sensorType.shortperiod')}</span>
            </label>
            <label htmlFor="channelFilter.byFeatures.broadband">
              <input type="checkbox" id="channelFilter.byFeatures.broadband"
                name="byFeatures.broadband" className="filled-in"
                onChange={handleCheckedStateChanged}
              />
              <span>{t('form.channel.sensorType.broadband')}</span>
            </label>
            <label htmlFor="channelFilter.byFeatures.accelerometer">
              <input type="checkbox" id="channelFilter.byFeatures.accelerometer"
                name="byFeatures.accelerometer" className="filled-in"
                onChange={handleCheckedStateChanged}
              />
              <span>{t('form.channel.sensorType.accelerometer')}</span>
            </label>
          </div>
        </div>
      }
      <label className="datatable_select_radio height45" htmlFor="channelFilter.selectorType.byCodes">
        <input type="radio" id="channelFilter.selectorType.byCodes"
          name="selectorType" value="byCodes" className="with-gap" 
          checked={state.selectorType === 'byCodes'}
          onChange={handleSelectorTypeChanged}
        />
        <span>{t('form.customInput')}</span>
      </label>
      <div className="input-field inline-block">
        <input type="text" name="channelCodes" placeholder="HG?, HA?"
          className="center-align multiinput2"
          title="입력 형식: HG?, B??, ?H?, ???, ..."
          aria-label="채널 직접 입력"
          onBlur={handleCustomInputValueChanged}
        />
      </div>
    </>
  )
}

